import { mapState, mapActions } from 'vuex'
import { compose, propOr, isEmpty, not, path } from 'ramda'
import { successMessage, warningMessage } from '@/utils/messages'

export default {
  computed: {
    pendingInviteNotification: compose(
      not,
      isEmpty,
      propOr({}, 'inviteNotification')
    ),
    pendingInviteNotificationOrganizationName: path(['inviteNotification', 'organizationName']),
    pendingInviteNotificationSuccess: path(['inviteNotification', 'success']),
    ...mapState('invite', [
      'inviteNotification'
    ])
  },
  methods: {
    ...mapActions('invite', [
      'clearInviteNotification',
    ])
  },
  watch: {
    pendingInviteNotification(newValue) {
      if(newValue) {
        if(this.pendingInviteNotificationSuccess) {
          successMessage(this.$t('common.invite_success', {
            organizationName: this.pendingInviteNotificationOrganizationName
          }))(this)
        } else {
          warningMessage(this.$t('common.invite_not_success', {
            organizationName: this.pendingInviteNotificationOrganizationName
          }))(this)
        }
      }

      return this.clearInviteNotification()
    }
  },
  render() {}
}
